<template>
  <div style="position: relative;top: -30px;">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1" class="item_span">企业用户</el-menu-item>
      <el-menu-item index="6" class="item_span" v-if="isManager">部门管理</el-menu-item>
      <el-menu-item index="2" class="item_span">产品管理</el-menu-item>
      <el-menu-item index="3" class="item_span">设备管理</el-menu-item>
      <el-menu-item index="4" class="item_span">分析统计</el-menu-item>
      <el-menu-item index="5" class="item_span">系统设置</el-menu-item>
    </el-menu>
    <div v-show="showCom">
      <company ></company>
    </div>
    <div v-show="showWeP">
      <weProduct></weProduct>
    </div>
    <div v-show="showDev">
      <device></device>
    </div>
    <div v-show="showSta">
      <statistics :defalutd='num'></statistics>
    </div>
    <div v-if="showSystem">
      <System :defalutd='num'></System>
    </div>
    
    <!-- 部门管理 -->
    <div class="depart-box" v-if="activeIndex == 6 && companymanageid">
      <DepartManage  :companymanageid="companymanageid" />
    </div>
  </div>
</template>
<script>
import {  API_Company, API__account } from '@/api/index.js'
import company from '../companys/Company'
import device from '../companys/Device'
import weProduct from '../companys/WeProduct'
import statistics from '../companys/Statistics'
import System from '../companys/system'
import DepartManage from '../companys/DepartManage/index.vue'
import  utils  from '@/utils/index'
export default {
  data(){
    return{
      num:1,
      activeIndex: '',
      showCom:true,
      showDev:false,
      showWeP:false,
      showSta:false,
      showSystem:false,
      companymanageid: '',
      isManager: false,
    }
  },
  methods: {
    // bak:function(){
    //   this.$router.push({path: '/company'});
    // },
    handleSelect(key) {
      this.showCom = false;
      this.showWeP = false;
      this.showDev = false;
      this.showSta = false;
      this.showSystem = false;
      if(key == '2'){
        this.showWeP = true;
        sessionStorage.setItem('admin_menu', '2');
      }else if(key == '3'){
        this.showDev = true;
        sessionStorage.setItem('admin_menu', '3');
      }else if(key == '4'){
        this.showSta = true;
        sessionStorage.setItem('admin_menu', '4');
      }else if(key == '5'){
        this.showSystem = true;
        sessionStorage.setItem('admin_menu', '5');
      }else if(key == '6'){
        sessionStorage.setItem('admin_menu', '6');
      }else{
        this.showCom = true;
        sessionStorage.setItem('admin_menu', '1');
      }
      if(key == '4'){
        this.num = 2;
      }else{
        this.num = 1;
      }
      this.activeIndex = key;
      // console.log(key, keyPath);
    },

    getDetial() {
      let { token, checkCode } = utils.getParamsByCookie();
      let params = {
        token: token,
        checkCode: checkCode,
        id:sessionStorage.getItem('dnnypt_id'),
      }
      API__account.accountDetail(params)
      .then((res)=>{
        if(res.data.code == 200){
           let data =  res.data.data;
           this.isManager = data.companymanageid != null
          if(data.companymanageid || data.companyuseid) {
            this.companymanageid = data.companymanageid? data.companymanageid: data.companyuseid;
          }
          console.log(" this.isManager==", data)
        }  
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
  },

  created(){
    this.getDetial()
  },

  mounted(){
    this.activeIndex = sessionStorage.getItem('admin_menu');
    this.activeIndex = this.activeIndex? this.activeIndex: '1'
    if(this.activeIndex == '2'){
      this.showCom = false;
      this.showDev = false;
      this.showWeP = true;
      this.showSta = false;
      this.showSystem = false;
      sessionStorage.setItem('admin_menu', 2);
    }else if(this.activeIndex == '3'){
      this.showDev = true;
      this.showCom = false;
      this.showWeP = false;
      this.showSta = false;
      this.showSystem = false;
      sessionStorage.setItem('admin_menu', 3);
    }else if(this.activeIndex == '4'){
      this.showDev = false;
      this.showCom = false;
      this.showWeP = false;
      this.showSta = true;
      this.showSystem = false;
      sessionStorage.setItem('admin_menu', 4);
    }else if(this.activeIndex == '5'){
      this.showDev = false;
      this.showCom = false;
      this.showWeP = false;
      this.showSta = false;
      this.showSystem = true;
      sessionStorage.setItem('admin_menu', 5);
    }else if(this.activeIndex == '6'){
      this.showDev = false;
      this.showCom = false;
      this.showWeP = false;
      this.showSta = false;
      this.showSystem = false;
      sessionStorage.setItem('admin_menu', 6);
    }else{
      this.showCom = true;
      this.showDev = false;
      this.showWeP = false;
      sessionStorage.setItem('admin_menu', 1);
    }
    this.handleSelect(this.activeIndex);
  },
  components: {
    company,
    device,
    weProduct,
    statistics,
    System,
    DepartManage
  },
}
</script>
<style>
.depart-box {
  width: 100%;
}
.item_span{
  font-size: 16px;
  font-weight: bold;
  font-family: 思源黑体 CN Bold Bold;
}
.el-menu{
  background-color: #F0F0F0;
}
.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #F66B3D;
    color: #F66B3D;
}
.el-menu--horizontal>.el-menu-item{
  color: #666;
}
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
  background-color: #F0F0F0;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
  color:#F66B3D;
}
</style>



// WEBPACK FOOTER //
// CompanyAll.vue?6de4f059